import { render, staticRenderFns } from "./EscalationTicketsTable.vue?vue&type=template&id=3a49fd86&"
import script from "./EscalationTicketsTable.vue?vue&type=script&lang=ts&"
export * from "./EscalationTicketsTable.vue?vue&type=script&lang=ts&"
import style0 from "./EscalationTicketsTable.vue?vue&type=style&index=0&id=3a49fd86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports